var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.5,
    height: 39.5,
    viewBox: "0 0 39.5 39.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-595.25 -788.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(612.027 792)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(596 789)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.712)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 3.406,
    transform: "translate(21.483 18.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76,442h3.795a2.145,2.145,0,0,1,1.691.825l3.139,4.015a2.146,2.146,0,0,1,.456,1.322v5.854a1.191,1.191,0,0,1-1.191,1.191h-.46",
    transform: "translate(-52.033 -437.047)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 4.231,
    transform: "translate(3.302 18.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62,436h7.65a1.431,1.431,0,0,1,1.431,1.431v16.73H63.651",
    transform: "translate(-49.603 -436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.6,458.3a3.3,3.3,0,1,1-3.3-3.3A3.3,3.3,0,0,1,62.6,458.3Z",
    transform: "translate(-48.563 -439.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.6,458.3a3.3,3.3,0,1,1-3.3-3.3A3.3,3.3,0,0,1,83.6,458.3Z",
    transform: "translate(-52.208 -439.316)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 7,
    transform: "translate(0 12.316)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 7,
    transform: "translate(3 8.316)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 7,
    transform: "translate(8.008 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.255,448.476H77V446",
    transform: "translate(-52.208 -437.745)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63,429.382a12.382,12.382,0,1,1,21.041,8.851",
    transform: "translate(-63 -417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78,422v8.255h5.778",
    transform: "translate(-65.618 -417.873)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.e5385b8885bf2f686ef487f586efa4c2.svg";
export { ForwardRef as ReactComponent };